import { render, staticRenderFns } from "./SubmitSignature.vue?vue&type=template&id=e98cc3c4"
import script from "./SubmitSignature.vue?vue&type=script&lang=js"
export * from "./SubmitSignature.vue?vue&type=script&lang=js"
import style0 from "./SubmitSignature.vue?vue&type=style&index=0&id=e98cc3c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports